import MeaSvgIconFolder from "./MeaSvgIconFolder";
import MeaSvgIconText from "./MeaSvgIconText";
import MeaSvgIconExcel from "./MeaSvgIconExcel";
import MeaSvgIconPDF from "./MeaSvgIconPDF";
import MeaSvgIconWord from "./MeaSvgIconWord";
import MeaSvgIconZip from "./MeaSvgIconZip";

const MeaSvgIcon = (props) => {
  const fileName = props.document?.name;
  var extension = "";
  if (fileName) {
    const parts = fileName.split('.');
    extension = parts.length > 1 ? parts.pop().toLowerCase() : '';
  }
  if (props.document?.is_folder) {
    return <MeaSvgIconFolder />;
  } else {
    switch (extension) {
      case 'zip':
      case 'tar':
      case 'gz':
        return <MeaSvgIconZip />
      case 'pdf':
        return <MeaSvgIconPDF />
      case 'doc':
      case 'docx':
        return <MeaSvgIconWord />
      case 'xls':
      case 'xlsx':
        return <MeaSvgIconExcel />
      default:
        return <MeaSvgIconText />;
    }
  }
};

export default MeaSvgIcon;